import React from 'react'
import styled from 'styled-components'
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts'
import { Text } from '@styles'
import { capitalizeEveryWord } from '@utils'

const ChartWrapper = styled.div`
	width: 100%;
	height: 100%;
	min-height: 22rem;
	max-height: 27rem;
`
const tickStyle = {
	fill: '#9ca3af',
	fontWeight: 400,
	fontSize: 10,
}

const TooltipBox = styled.div`
	background: #fff;
	border: 1px solid #e5e7eb;
	padding: 8px 12px;
	border-radius: 6px;
	font-size: ${Text.SMALL};
	box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
`

const TooltipTitle = styled.p`
	margin: 0;
	font-weight: ${Text.BOLD_600};
	color: #111827;
`

const TooltipText = styled.p`
	margin: 0;
	color: #374151;
`

const CustomTooltip = ({ active, payload, label, dataKeys, ToolTipUnit }) => {
	if (active && payload && payload.length) {
		const data = payload[0].payload
		return (
			<TooltipBox>
				<TooltipTitle>{label}</TooltipTitle>
				{dataKeys.map((key) => (
					<TooltipText key={key}>
						{capitalizeEveryWord(key.replace(/_/g, ' '))}: {data[key] ?? '-'}
						{ToolTipUnit}
					</TooltipText>
				))}
			</TooltipBox>
		)
	}
	return null
}

const BarCharts = ({ data = [], dataKeys = [], colors = [], ToolTipUnit = 'MT' }) => {
	return (
		<ChartWrapper>
			<ResponsiveContainer>
				<BarChart data={data} barGap={4} margin={{ top: 30, right: 10, left: 0, bottom: 0 }}>
					<CartesianGrid strokeDasharray='3 3' vertical={false} stroke='#e5e7eb' />
					<XAxis
						dataKey='month'
						tick={tickStyle}
						axisLine={false}
						tickLine={false}
						dy={10}
						interval={0}
						tickFormatter={(value) => {
							const [month, year] = value.split(' ')
							return `${month} ${year?.slice(-2)}`
						}}
					/>
					<YAxis
						tick={tickStyle}
						axisLine={false}
						tickLine={false}
						allowDecimals={false}
						dx={5}
						tickFormatter={(val) =>
							ToolTipUnit === 'Cr'
								? `${new Intl.NumberFormat().format(val)}\u00A0${ToolTipUnit}`
								: `${new Intl.NumberFormat().format(val / 1000)}${val === 0 ? '' : 'k'}\u00A0${ToolTipUnit}`
						}
					/>
					<Tooltip content={<CustomTooltip dataKeys={dataKeys} ToolTipUnit={ToolTipUnit} />} cursor={{ fill: 'rgba(0,0,0,0.05)' }} />
					{dataKeys.map((key, idx) => (
						<Bar key={key} dataKey={key} fill={colors[idx] || '#8884d8'} barSize={18} radius={[8, 8, 0, 0]} />
					))}
				</BarChart>
			</ResponsiveContainer>
		</ChartWrapper>
	)
}

export default BarCharts
